import ReactDOM from 'react-dom';

import { canUseDOM } from 'yafrpl/dom';
import { ReactPortal, ReactNode } from 'react';

const portals: { selector: string; children: ReactNode }[] = [];

export const DEFAULT_PORTAL_ID = '#portal-container';

export const createPortal = (
  children: ReactNode,
  selector = DEFAULT_PORTAL_ID
): ReactPortal | null => {
  if (!canUseDOM()) {
    portals.push({ selector, children });
    return null;
  }

  return ReactDOM.createPortal(
    children,
    document.querySelector(selector) || document.body
  );
};

export const flushPortals = (): { selector: string; children: ReactNode }[] => {
  const copy = [...portals];
  portals.length = 0;
  return copy;
};

export const lib = {};
